import { apiClient } from '../../axios';
import { GetRestrictedCountriesResponse } from './types';

export const getRestrictedCountriesApi = () => apiClient.get<GetRestrictedCountriesResponse>('/v2/countries');
